<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-bug"></i> {{ _('Issues') }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6 filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 filtercol">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Display') }}</div>
              <select class="form-control" id="issueTypeFilter" v-model="type">
                <option value="all">{{ _('All issues') }}</option>
                <option value="notacknowledged">{{ _('Not acknowledged issues') }}</option>
                <option value="acknowledged">{{ _('Acknowledged issues') }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <Datatable :url="issuesUrl" :search="search" :status-filter="status" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      issues: [],
      search: '',
      type: 'all',
      tableOptions: {
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Date'),
          field: 'ts',
          widthGrow: 1,
          formatter: this.dateAndTimeFormatter(),
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 1,
          formatter: this.issueTypeFormatter()
        },
        {
          title: _('Message'),
          field: 'message',
          width: 300,
          formatter: 'html'
        },
        {
          title: _('Item type'),
          field: 'reftype',
          widthGrow: 1
        },
        {
          title: _('Item id'),
          field: 'ref',
          widthGrow: 1
        },
        {
          title: _('Status'),
          field: 'status',
          widthGrow: 1,
          formatter: this.issueStatusFormatter()
        }
        ],
        initialSort: [{
          column: 'id',
          dir: 'desc'
        }],
        rowClick (e, row) {
          $this.editRow(row)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    issuesUrl () {
      return this.baseDomain + this.shopId + '/issues.json?apikey=' + this.apiKey + '&rawformat=true'
    },
    status: {
      get () {
        switch (this.type) {
          case 'notacknowledged':
            return String(this.STATUS_NOTACKNOWLEDGED)
          case 'acknowledged':
            return String(this.STATUS_ACKNOWLEDGED)
          default:
            return null
        }
      },
      set (newValue) {
        switch (parseInt(newValue)) {
          case this.STATUS_NOTACKNOWLEDGED:
            this.type = 'notacknowledged'
            break
          case this.STATUS_ACKNOWLEDGED:
            this.type = 'acknowledged'
            break
        }
      }
    }
  },
  methods: {
    editRow (row) {
      let id = row.getCell('id').getValue()
      let type = row.getCell('type').getValue()
      this.editIssue(id, type)
    },
    editIssue (id, type) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'IssueDetails',
        title: this._('Issue') + ' ' + id + (type ? ': ' + type : ''),
        width: 6,
        data: {
          issueId: id
        }
      })
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['issueUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>